<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<web-design-system-button size="small" (click)="openForm()" id="user-self-service-openForm-portfolio-report">
  {{ 'user-self-service.portfolio-report.open-form-button' | transloco }}
</web-design-system-button>

<div class="row">
  @if (formOpened) {
    <div class="input-group-material mt-5 mb-2" [class.input-group-material--error]="!dueDateInputVar.value && dueDateInputVar.touched">
      <input
        type="text"
        [class.empty]="!dueDateInputVar.value"
        [(ngModel)]="portfolioReportFacade.dueDate"
        id="dueDate"
        name="dueDateInput"
        #dueDateInputVar="ngModel"
        ngbDatepicker
        #d="ngbDatepicker"
        [maxDate]="maxDate"
        (dblclick)="d.open()"
        [disabled]="portfolioReportFacade.initiated"
        webAppServicesGermanNgbDateValidator
        required
        data-zid="dueDate"
      />
      <span class="input-group-material-icon-state"></span>
      <label for="dueDate">{{ 'user-self-service.portfolio-report.hint-due-date-required' | transloco }}</label>
      @if (!dueDateInputVar.value || dueDateInputVar.valid) {
        <div class="input-group-material-message">&nbsp;</div>
      }
      @if (
        dueDateInputVar.hasError('ngbDate') &&
        dueDateInputVar.getError('ngbDate').hasOwnProperty('maxDate') &&
        !dueDateInputVar.hasError('noValidGermanDate')
      ) {
        <div class="input-group-material-message">{{ 'user-self-service.portfolio-report.hint-due-date' | transloco }}</div>
      }
      @if (
        (dueDateInputVar.hasError('ngbDate') &&
          (dueDateInputVar.getError('ngbDate').hasOwnProperty('requiredBefore') ||
            dueDateInputVar.getError('ngbDate').hasOwnProperty('invalid'))) ||
        dueDateInputVar.hasError('noValidGermanDate')
      ) {
        <div class="input-group-material-message">{{ 'user-self-service.portfolio-report.hint-due-date-error-invalid' | transloco }}</div>
      }
    </div>
    <web-design-system-button
      size="small"
      [class.mt-4]="portfolioReportFacade.initiated"
      [disabled]="!portfolioReportFacade.dueDate || dueDateInputVar.hasError('ngbDate')"
      (click)="requestReport()"
      id="user-self-service-request-portfolio-report"
    >
      {{ 'user-self-service.portfolio-report.request-button' | transloco }}
    </web-design-system-button>
  }

  @if (portfolioReportFacade.dataToAuthorize | async; as dataToAuthorize) {
    <div class="row mt-4">
      <div class="col-12">
        <span>{{ 'user-self-service.portfolio-report.note' | transloco }}</span>
        <br /><br />
        <web-components-transaction-auth [payload]="dataToAuthorize" (transactionResult)="handleAuthenticationResult($event)" />
      </div>
    </div>
  }

  @if (portfolioReportFacade.initiated && !portfolioReportFacade.succeeded) {
    <div class="text-color-error mt-2">
      {{ portfolioReportFacade.errorMessage }}
    </div>
  }
</div>
